<template>
  <div class="app-container">
    <MainNavbar v-if="!$route.meta.hideNavigation" />
    <main class="content-wrapper">
      <router-view />
    </main>
    <MainFooter v-if="!$route.meta.hideNavigation" />
  </div>
</template>

<script>
import MainNavbar from '@/components/MainNavbar.vue'
import MainFooter from '@/components/MainFooter.vue'
import '@/style/HardwareDetails.css'
import '@/style/SoftwareDetails.css'
import '@/style/TypicalcaseDetails.css'

export default {
  name: 'App',
  components: {
    MainNavbar,
    MainFooter,
  }
}
</script>

<style>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

body {
  width: 100%;
  height: 100%;
  margin: 0 auto;
  padding: 0;
  overflow-x: hidden;
}
</style>
